module.exports = __webpack_public_path__ + "media/22.df6b9cab.wav";